import { Drawer, IconButton, ListItem } from '@mui/material';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import { MOBILE_BREAKPOINT } from '@src/styles/config';
import styled from 'styled-components';

export const StyledMobileTTS = styled.div`
  width: 100%;
  height: ${(props) =>
    props.screenHeight && props.isResizeTTS
      ? `calc(${props.screenHeight - 150}px)` // 150 is height of header and footer
      : '96%'};
  display: flex;
  flex-direction: column;

  .page-container {
    background-color: ${COLOR.white};
    padding: 0px 8px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .page-container-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .box-preview-desc {
      padding: 0px 10px;
      border-radius: 480px;
    }

    .preview-group {
      display: flex;
      align-items: center;
    }

    .preview-desc {
      font-size: 12px;
      color: ${COLOR.black.default};
      letter-spacing: -0.4px;
    }
    .preview-understood {
      color: #007aff;
      text-decoration: underline;
      cursor: pointer;
    }

    .preview-button {
      font-size: 12px;
      padding: 8px 16px 8px 8px;
      border-radius: 32px;
      text-transform: none;
      border: 1px solid ${COLOR.darkV2[32]};
      font-weight: 500;
    }

    .preview-button-icon {
      margin-right: -6px;
    }
  }

  .text-area-input {
    width: 100%;
    flex: 1;
    border-radius: 4px;
    font-size: 16px;
    box-sizing: border-box;
    resize: none;
    border: none;
    outline: none;
    background-color: ${COLOR.white};
    font-family: 'SF Pro', sans-serif;
    color: ${(props) =>
      props.isPlaying ? COLOR.label2[64] : COLOR.label2[100]};
    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    &::-webkit-scrollbar-track {
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar-thumb {
      background: ${COLOR.indigo[64]};
      border-radius: 100px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${COLOR.indigo[80]};
      border-radius: 100px;
    }
  }

  .text-area-input:disabled {
    background-color: ${COLOR.white};
    opacity: 1;
  }

  .count-characters {
    text-align: right;
    text-transform: lowercase;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
    letter-spacing: -0.4px;
    padding-top: 4px;
    color: ${(props) =>
      props.isTooManyChars ? COLOR.error : COLOR.label2[100]};
  }
  .count-characters-max {
    color: ${COLOR.label[64]};
  }

  .close-button {
    font-size: 14px;
    font-weight: 700;
    border-radius: 4px;
  }

  .tool-row {
    padding-bottom: 8px;
  }
`;

export const StyledAudioPlayer = styled.div`
  width: 100%;
  height: 56px;
  box-sizing: border-box;

  .audio-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: transparent;
    padding: 12px 16px 4px 16px;
    box-sizing: border-box;

    .audio-info-right-group {
      width: 90px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .audio-info-left-group {
      width: 90px;
      display: flex;
      gap: 16px;

      .break-time-button {
        color: ${COLOR.indigo[64]};
      }
      .break-time-button:disabled {
        color: ${COLOR.disableButton};
        opacity: 1;
      }
    }

    .rewind-button {
      padding: 6px;
      color: ${COLOR.indigo[64]};
    }
  }

  .control-audio {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .audio-action-button {
    padding: 6px;
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    min-width: 0;
  }

  .voice {
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .speed {
    color: ${COLOR.indigo[100]};
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    border: 2px solid ${COLOR.indigo[64]};
    border-radius: 100px;
    cursor: pointer;
  }
`;

export const StyledSpeedDrawer = styled.div`
  width: 100%;
  .MuiList-root {
    padding: 0px;
  }
  .list-item {
    margin-bottom: 2px;
    padding: 0;
    font-size: 14px;
    font-weight: 500;
    box-sizing: border-box;
    min-width: 100px;
  }

  .list-item:last-child {
    margin-bottom: 0;
  }

  .list-item .MuiListItemButton-root {
    width: 100%;
    height: 100%;
    padding: 8px 16px;
    justify-content: center;
  }

  .item-break-time {
    display: flex;
    justify-content: center;
    padding: 6px 16px;
  }

  .show-speed {
    display: flex;
    align-items: center;
    padding: 6px 16px;
    width: 160px;

    .speed-value {
      width: 70px;
      text-align: left;
    }

    .speed-title {
      text-align: left;
    }
  }

  .speed-input-container {
    display: flex;
    align-items: center;

    .MuiOutlinedInput-root {
      padding-right: 8px;
      background: ${(props) => props.inputValue && 'rgba(30, 22, 78, 0.08)'};
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: -0.4px;
      border-radius: 8px;
    }

    .MuiInputBase-input {
      padding: 12px;
      text-align: center;
    }
  }

  .speed-input {
    color: ${COLOR.darkGray};
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.4px;
    flex: 1;
    border-radius: 8px;
    padding: 0px 16px 16px 16px;
  }

  .break-time-input {
    color: ${COLOR.darkGray};
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.4px;
    flex: 1;
    border-radius: 8px;
    padding: 0px 16px 16px 16px;

    .MuiInputBase-input {
      margin-left: ${(props) => (props.inputValue ? '35px' : '0px')};
    }
  }

  .icon-choose-speed-input {
    cursor: pointer;
    color: ${(props) =>
      props.inputValue &&
      props?.inputValue >= props?.minValue &&
      props.inputValue <= props?.maxValue
        ? COLOR.blueV2
        : 'gray'};
  }
`;

export const StyledDrawer = styled(Drawer)`
  .MuiPaper-root {
    border-radius: 16px 16px 0px 0px;
  }
  .drawer-title {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;
    padding: 0 16px;
    background-color: ${COLOR.divider};
    border-bottom: 1px solid ${COLOR.label[16]};
    height: 48px;

    svg:hover {
      cursor: pointer;
    }

    .title {
      font-size: 16px;
      font-weight: bold;
      text-transform: none;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      color: ${COLOR.label2[100]};
      text-overflow: ellipsis;
    }
  }
`;

export const StyledListItem = styled(ListItem)`
  background-color: ${(props) =>
    props.isSelected ? COLOR.indigo[8] : COLOR.white};
`;

export const StyledLoading = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledVoiceDrawer = styled.div`
  width: 100%;
  // height: ${(props) => (props.openSearchPanel ? '420px' : '340px')};
  height: 400px;
  overflow: auto;
  margin: 0px;
  // transition: height 0.5s ease;
  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    background: ${COLOR.white};
  }
  &::-webkit-scrollbar-thumb {
    background: ${COLOR.indigo[64]};
    border-radius: 100px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: ${COLOR.indigo[80]};
    border-radius: 100px;
  }

  .list {
    padding: 0 0px;
  }

  .list-item {
    font-size: 16px;
    font-weight: 500;
    box-sizing: border-box;
    min-width: 100px;
    margin: 0px;
    background: ${(props) =>
      props.active ? TRANSPARENT_COLOR.primary : COLOR.white};
  }

  .list-item:last-child {
    margin-bottom: 0;
    border-bottom: 0px;
  }

  .MuiListItem-root {
    padding: 0px;
  }

  .list-item .MuiListItemButton-root {
    width: 100%;
    height: 100%;
    padding: 0px;
    margin: 0px 16px;
    border-bottom: 1px solid ${COLOR.label[16]};
    background: ${(props) =>
      props.active ? TRANSPARENT_COLOR.primary : COLOR.white};
  }

  .empty-voices {
    margin: 25% 25%;
    width: 50%;
  }
`;

export const StyledVoiceDrawerToolbar = styled.div`
  width: 100%;
  padding: 16px 16px 8px 16px;
  box-sizing: border-box;
  .voice-drawer-toolbar-row {
    display: flex;
    height: 34px;
    align-items: center;
    position: relative;
    gap: 4px;
  }
  .search-button {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background-color: rgba(245, 245, 247, 1);
  }

  .search-panel {
    width: 100%;
    position: relative;
  }

  .search-input {
    width: 100%;
    height: 34px;
    padding: 8px;
    box-sizing: border-box;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.4px;
    border: solid 1px ${COLOR.label[16]};
    border-radius: 8px;
    outline: none;
  }

  .clear-icon {
    position: absolute;
    width: 24px;
    height: 24px;
    color: ${COLOR.black[54]};
    top: 50%;
    right: 4px;
    transform: translateY(-50%);
  }

  .gender-box-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    background: ${COLOR.white};
    border: 1px solid ${COLOR.darkV2[32]};
  }

  .gender-button {
    display: flex;
    width: fit-content;
    height: 32px;
    padding: 0px 12px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    text-transform: none;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.4px;
    color: ${COLOR.label2[100]};
    border-radius: 0;
  }

  .all {
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
  }

  .male {
    border-right: 1px solid ${COLOR.darkV2[32]};
    border-left: 1px solid ${COLOR.darkV2[32]};
  }

  .female {
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
  }

  .selected {
    background: ${COLOR.indigo[100]};
    color: ${COLOR.white};
  }

  .language-box-button {
    border: none;
    display: flex;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    justify-content: center;
    background-color: transparent;
    align-items: center;
    height: 32px;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.4px;
    // gap: 4px;
  }

  .img-flag {
    width: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }

  .arrow-icon {
    font-size: 24px;
  }
`;

export const StyledVoice = styled.button`
  width: 100%;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 16px 0px;
  margin: 0px;
  border: none;
  background-color: transparent;
  .content {
    display: flex;
    flex-direction: column;
    padding: 0px 12px;
    flex: 1;
    gap: 4px;
  }

  .more-info-voice-box {
    display: flex;
    align-items: center;
    gap: 8px;
    .tag-voice {
      background-color: #ffd60a;
      padding: 2px 8px;
      border-radius: 500px;
      font-size: 12px;
      color: #1c1c1e;
      height: 24px;
      letter-spacing: -0.4px;
      display: flex;
      align-items: center;
      text-align: center;
    }
    .tag-voice-beta {
      background-color: #007aff29;
      padding: 2px 8px;
      border-radius: 500px;
      font-size: 12px;
      color: #007aff;
      height: 24px;
      letter-spacing: -0.4px;
      display: flex;
      align-items: center;
      text-align: center;
    }

    .eol-tag-name {
      background-color: ${COLOR.bgRedPrimary};
      padding: 2px 8px;
      border-radius: 500px;
      font-size: 12px;
      height: 24px;
      color: ${COLOR.redPrimary};
      letter-spacing: -0.4px;
      display: flex;
      align-items: center;
      text-align: center;
      gap: 4px;

      .returning-error-icon {
        color: ${COLOR.redPrimary};
        font-size: 14px;
        cursor: pointer;
      }
    }
  }

  .discontinued-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.4px;
    color: ${COLOR.redPrimary};
    font-weight: 400;
    .returning-error-icon {
      font-size: 14px;
      margin-right: 4px;
    }
  }

  .x2-char-tag {
    background-color: #007aff14;
    color: #007aff;
    font-size: 12px;
    border-radius: 500px;
    padding: 2px 8px;
    box-sizing: border-box;
    width: 30px;
    height: 24px;
    display: flex;
    align-items: center;
    margin-left: 4px;
    text-align: center;
  }

  .voice-name {
    font-size: 16px;
    font-style: normal;
    font-weight: 510;
    line-height: 24px; /* 150% */
    letter-spacing: -0.4px;
    text-align: left;
    color: ${COLOR.label2[100]};
    display: flex;
    align-items: center;
  }

  .voice-infor {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    letter-spacing: -0.4px;
    color: ${COLOR.label[64]};
  }

  .icon-button {
    padding: 6px;
  }

  .play-icon {
    padding: 0px;
  }
`;

export const StyledLanguageSlider = styled.div`
  display: flex;
  width: 100%;
  overflow: auto;
  margin-top: 8px;
  gap: 8px;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledLanguage = styled.div`
  min-width: fit-content;
  .language-button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px;
    background-color: rgba(244, 245, 247, 1);
    border: none;
    border-radius: 12px;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.4px;
    cursor: pointer;
  }

  .language-button-img {
    width: 16px;
  }

  .language-name {
    color: ${COLOR.black};
  }

  .selected-language {
    background-color: ${COLOR.yellow[16]};
    border: 1px solid ${COLOR.primary};
  }
`;

export const StyledVoiceFilter = styled.div`
  display: flex;
  gap: 10px;
  padding: 4px;
  border-radius: 12px;
  background-color: ${COLOR.indigo[8]};
  margin: 16px 16px 0px 16px;

  .filter-button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 8px;
    border-radius: 12px;
    background-color: transparent;
    cursor: pointer;
    text-transform: none;
    color: ${COLOR.label2[48]};
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
  }

  .active-button {
    background-color: ${COLOR.white} !important;
    color: ${COLOR.indigo[100]} !important;
  }
`;

export const StyledIconButton = styled(IconButton)`
  width: ${({ width }) => width || 'auto'};
  padding: ${({ padding }) => padding || '0px'};
  height: ${({ height }) => height || '10px'};
  border-radius: ${({ borderRadius }) => borderRadius || '100%'};
  padding: 18px;
  background: ${({ focus }) => focus && TRANSPARENT_COLOR.dark};

  color: ${({ color }) => (color ? COLOR[color] : COLOR.indigo[64])};
  opacity: 0.75;
  &:hover {
    background: ${TRANSPARENT_COLOR.dark};
    opacity: 1;
    .icon {
      color: ${({ colorHover }) => COLOR[colorHover]};
    }
  }

  .text-action {
    font-size: 14px;
    color: ${COLOR.darkBlue};
    &:hover {
      color: ${COLOR.black};
    }
  }
`;

export const StyledActionWarning = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;

  .cancel-btn {
    display: flex;
    border-radius: 500px;
    border: 1px solid rgba(30, 22, 78, 0.32);
    padding: 10px 24px;
    justify-content: center;
    align-items: center;

    color: ${COLOR.darkBlue};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.4px;
  }

  .agree-btn {
    display: flex;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 500px;
    border: 1px solid ${COLOR.primary};
    background-color: ${COLOR.primary};

    color: ${COLOR.darkBlue};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.4px;
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .agree-btn,
    .cancel-btn {
      width: 50%;
    }
  }
`;

export const StyledBlackWord = styled('span')`
  color: red;

  &:not(:last-child)::after {
    content: ', ';
    color: #242424;
  }
`;
